import { formatPrice } from '@grandvisionhq/svc-tealium/utils';
import { getLocalizedString } from '@grandvisionhq/utils';

const getOrderPriceInfo = (order)=>{
    const Order_ProductsAmount = order.rawLineItems.reduce((prev1, next1)=>{
        const productDiscount = next1.price.unit.discount.appliedDiscounts.filter((item)=>item.type === 'PRODUCT_DISCOUNT'
        ).reduce((prev, next)=>prev + next.amount
        , 0);
        return prev1 + (next1.price.unit.subtotal - productDiscount) * next1.quantity;
    }, 0);
    return {
        Order_Subtotal: order.totalPrice && order.taxAmount ? formatPrice(order.totalPrice - order.taxAmount - order.shippingMethodPrice, true) : '0',
        Order_Total: order.totalPrice ? formatPrice(order.totalPrice, true) : '0',
        Order_TaxAmount: (order === null || order === void 0 ? void 0 : order.taxAmount) ? formatPrice(order.taxAmount, true) : '0',
        Order_ShippingTaxRate: (order === null || order === void 0 ? void 0 : order.shippingTaxRate) ? formatPrice(order.shippingTaxRate, false) : '0',
        Order_ShippingDiscount: order.shippingDiscount ? `-${formatPrice(order.shippingDiscount, true)}` : '0',
        Order_ShippingAmount: formatPrice(order.shippingMethodPrice, true),
        Order_ProductsAmount: formatPrice(Order_ProductsAmount, true)
    };
};
const orderToTealiumOrderDiscountInfo = (order)=>{
    var ref;
    const localizedDiscounts = [];
    const discountCodes = [];
    (ref = order.discountCodes) === null || ref === void 0 ? void 0 : ref.forEach((discountItem)=>{
        discountCodes.push(discountItem.code);
        const localizedName = getLocalizedString(discountItem.name, 'en');
        localizedName && localizedDiscounts.push(localizedName);
    });
    const orderDiscount = (order === null || order === void 0 ? void 0 : order.appliedDiscounts) ? order.appliedDiscounts.filter((item)=>item.type === 'CART_DISCOUNT'
    ).reduce((prev, next)=>prev + next.value
    , 0) : 0;
    return {
        Order_DiscountAmount: orderDiscount ? `-${formatPrice(orderDiscount, true)}` : '0',
        Order_DiscountCode: discountCodes.join(),
        Order_DiscountName: localizedDiscounts.join()
    };
};
const getOrderSubscriptionFrequency = (order)=>{
    if (!order.hasSubscription) {
        return '0';
    } else {
        const subscriptionProduct = order.lineItems.filter((item)=>'subscriptionDetails' in item
        )[0];
        if (!subscriptionProduct || !subscriptionProduct.subscriptionDetails) {
            return '0';
        } else {
            return Math.floor(subscriptionProduct.subscriptionDetails.deliveryInterval / 30).toFixed(1);
        }
    }
};

export { getOrderPriceInfo, getOrderSubscriptionFrequency, orderToTealiumOrderDiscountInfo };
//# sourceMappingURL=tealium-mapper.js.map
